<template>
  <div id="notes">
    <!-- remove card when animation ends by removing it from array -->
    <Transition v-for="card in notes" :key="card.id">
      <div
        v-if="card.active"
        class="float card"
        :key="'card' + card.timestamp"
        :style="{
          left: card.x + 'px',
          top: card.y + 'px',
          animationDuration: Math.random() * 7 + 15 + 's',
          animationDirection: Math.random() > 0.5 ? 'normal' : 'reverse',
        }"
      >
        <Markdown
          :source="card.front"
          :class="{
            'normal-text': card.front.length > 100,
            'align-left': card.front.length > 100,
          }"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import { supabase } from "../supabase";
import Markdown from "vue3-markdown-it";

export default {
  data() {
    return {
      collectionsFilterClean: [],
      notes: [],
      intervalId: null,
    };
  },
  components: {
    Markdown,
  },
  mounted: async function () {
    // fill this.notes with 25 objects of the scheme:
    // { front: "", x: random, y: random, active: false }
    for (let i = 0; i < 5; i++) {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const randomX = Math.floor(Math.random() * width) - 600;
      const randomY = Math.floor(Math.random() * height) - 200;
      this.notes.push({
        front: "",
        x: randomX,
        y: randomY,
        active: false,
        timestamp: new Date(),
      });
    }
    this.createAnimation();
  },
  methods: {
    async createAnimation() {
      const container = document.getElementById("notes");
      // get the width and height of the viewport

      let collectionsFilterClean = [];

      try {
        const { data, error } = await supabase
          .from("packs")
          .select("id, name")
          .match({ user_id: supabase.auth.currentUser.id, isDisabled: false });
        if (error) throw error;
        collectionsFilterClean = data.map((collection) => collection.id);
      } catch (error) {}

      async function getRandomNote() {
        // get a random note from user's notes

        const { data, error } = await supabase.rpc(
          "get_random_card_with_type_filter",
          {
            id_of_user: supabase.auth.currentUser.id,
            type_filter: ["standard"],
            collections_filter: collectionsFilterClean,
            due: new Date() / 1000,
          }
        );
        if (error) {
        }

        // get the note's front and back
        const { data: noteData, error: noteError } = await supabase
          .from("cards")
          .select("front, back")
          .eq("id", data[0].id)
          .single();
        if (noteError) {
        }

        return noteData;
      }

      // get one initial note so no wait
      getRandomNote().then((note) => {
        // pick a random note from the array and replace front
        const randomNote =
          this.notes[Math.floor(Math.random() * this.notes.length)];
        randomNote.front = note.front;
        randomNote.active = true;
      });

      // every 1 seconds, add a new random note
      // place it at a random edge of the container
      // give it a random direction via CSS animation
      // destroy it when it leaves the container
      this.intervalId = setInterval(() => {
        getRandomNote().then((note) => {
          // pick a random note from the array and replace front
          const randomNote =
            this.notes[Math.floor(Math.random() * this.notes.length)];
          randomNote.front = note.front;
          randomNote.active = true;
          randomNote.timestamp = new Date();
        });
      }, 1000);
    },
  },
  computed: {},
  // remove interval when other view is loaded
  beforeRouteLeave(to, from, next) {
    clearInterval(this.intervalId);
    next();
  },
  
};
</script>
